import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ServicedOfficeIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M24 14V16H23C22.4482 16 22 16.4487 22 17V23H20V17C20 16.6494 20.0606 16.313 20.1709 16H3.85254C3.96289 16.313 4.02344 16.6494 4.02344 17V23H2.02344V17C2.02344 16.4487 1.5752 16 1.02344 16H0V14H24ZM5 7V4C5 2.3457 6.3457 1 8 1H16C17.6543 1 19 2.3457 19 4V7C19 8.6543 17.6543 10 16 10H13.0013L15.5173 12.5H8.4953L10.995 10H7.99999C6.34569 10 4.99999 8.6543 4.99999 7H5ZM7 7C7 7.55127 7.44824 8 8 8H16C16.5518 8 17 7.55127 17 7V4C17 3.44873 16.5518 3 16 3H8C7.44824 3 7 3.44873 7 4V7Z",
    fill: "currentColor"
  }));
}